<template>
  <div class="banner">
    <div class="banner-body">
      <div class="banner-filter">
        <span class="banner-filter-title">海量真实房源 让住更安心</span>
        <dl>
          <dt>选择区域</dt>
          <dd v-for="(a, i) in district" :key="a.code" @click="go(i, 'region')">{{ a.name }}</dd>
        </dl>
        <dl>
          <dt>选择面积</dt>
          <div class="range">
            <template v-for="(a, i) in area" :key="a.code">
              <span class="range-item" @click="go(i, 'area')">{{ a }}</span>
            </template>
          </div>
        </dl>
        <div class="banner-filter-btn">
          <div class="btn" @click="$router.push({ name: 'house.first-sale' })">看新房</div>
          <div class="btn" @click="$router.push({ name: 'house.sale' })">二手房</div>
          <div class="btn" @click="$router.push({ name: 'house.rent' })">找租房</div>
          <div class="btn" @click="$router.push({ name: 'house.building' })">查小区</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const district = ref([]);
const area = ref([]);
const getBase = async () => {
  app.dict.BaseData.map((_) => {
    if (_.dicCode === 'areaList') {
      const arr = [];
      _.subData.map((a) => arr.push(a.min));
      area.value = arr;
    }
  });
  district.value = app.dict.AreaData ?? [];
};
const go = (i, m) => {
  let query = {};
  if (m === 'region') query.regionIndex = i;
  if (m === 'area') query.areaIndex = i;
  router.push({ name: 'house.sale', query });
};
getBase();
</script>

<style lang="scss" scoped>
.banner {
  background-image: url('https://static.ajl.cn/web/house/banner.png');
  min-height: 500px;
  background-size: cover;
  background-position: center;
  &-body {
    height: inherit;
    min-height: inherit;
    margin: auto;
    width: 1050px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-filter {
    width: 600px;
    height: 260px;
    background-color: white;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    position: relative;
    top: 10rem;
    &-title {
      font-size: 5rem;
      position: absolute;
      top: -10rem;
      left: 2rem;
      color: white;
    }
    dl {
      display: grid;
      gap: 1rem;
      grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
      position: relative;
      padding: 6rem 2rem 0;
      margin: 1rem;
      dt {
        position: absolute;
        top: 2rem;
        left: 2rem;
        font-size: 2rem;
      }
      dd {
        font-size: 2rem;
        opacity: 0.6;
        text-align: left;
        cursor: pointer;

        &:hover {
          color: var(--color);
          opacity: 1;
        }
      }

      .range {
        grid-column: 1/7;
        display: flex;
        justify-content: space-between;

        &-item {
          flex: 1;
          padding-top: 3rem;
          font-size: 2rem;
          position: relative;
          height: 4rem;
          cursor: pointer;
          text-align: left;
          left: -1rem;
          &:nth-child(1) {
            text-indent: 1rem;
          }
          &:nth-child(6):after {
            content: '∞';
            position: absolute;
            right: -1rem;
          }
          &:hover {
            color: var(--color);
            &:before {
              background-color: var(--color);
            }
          }
          &:before {
            content: '';
            position: absolute;
            z-index: 0;
            top: -0rem;
            left: 1rem;
            width: 95%;
            height: 2rem;
            background-color: #ccc;
            border-radius: 4px;
          }
        }
      }
    }
    &-btn {
      width: 90%;
      margin: 4rem auto;
      display: flex;
      justify-content: space-between;
      .btn {
        width: 120px;
        color: white;
        background-color: var(--color);
        font-size: 2rem;
        padding: 1rem;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          box-shadow: 0 0 3px var(--color10);
        }
      }
    }
  }
}
</style>
